/**
 * GeChiUI dependencies
 */
import { createContext } from '@gechiui/element';

const InserterListboxContext = createContext();

export default InserterListboxContext;
